import { screen, waitFor } from "@testing-library/react";
import Terria from "../../lib/Models/Terria";
import ViewState from "../../lib/ReactViewModels/ViewState";
import Tool from "../../lib/ReactViews/Tools/Tool";
import { renderWithContexts } from "./withContext";
import { jsx as _jsx } from "react/jsx-runtime";
const TestComponent = () => /*#__PURE__*/_jsx("div", {
  children: "Test hello"
});
describe("Tool", function () {
  let viewState;
  beforeEach(function () {
    const terria = new Terria();
    viewState = new ViewState({
      terria,
      catalogSearchProvider: undefined
    });
  });
  it("renders the item returned by getToolComponent", async function () {
    renderWithContexts(/*#__PURE__*/_jsx(Tool, {
      toolName: "test-tool",
      getToolComponent: () => TestComponent
    }), viewState);
    await waitFor(() => expect(screen.getByText("Test hello")).toBeVisible());
  });
  it("renders the promised item returned by getToolComponent", async function () {
    renderWithContexts(/*#__PURE__*/_jsx(Tool, {
      toolName: "test-tool",
      getToolComponent: () => Promise.resolve(TestComponent)
    }), viewState);
    await waitFor(() => expect(screen.getByText("Test hello")).toBeVisible());
  });
});